<template>
  <v-dialog v-model="toggle" persistent width="500">
    <v-card outlined class="text-left r0">
      <v-container>
        <template>
          <h3 class="mt-1">Rich Menu ดีอย่างไร</h3>
          <v-list-item>
            <img
              :src="template"
              contain
              class="img border-icon ma-5 pointer"
              width="58"
            />
            <v-list-item-content>
              Rich menus ของเรามี Template ให้เลือกมากกว่าที่เคย
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <img
              :src="edit"
              contain
              class="img border-icon ma-5 pointer"
              width="58"
            />
            <v-list-item-content> สามารถปรับแต่งเองได้ </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <img
              :src="link"
              contain
              class="img border-icon ma-5 pointer"
              width="58"
            />
            <v-list-item-content>
              มี action dynamic ที่ไม่เหมือนใคร เปลี่ยน rich menu ได้เลย
            </v-list-item-content>
          </v-list-item>
        </template>

        <template>
          <div class="btn-sticky mt-16 pr-pl-12">
            <v-btn outlined class="btn-back-richmenu w45 br-7" @click="back"
              >Back</v-btn
            >
            <v-btn
              outlined
              class="btn-custom btn-next-richmenu w45 right"
              @click="goToPageLineConnenct"
              ><span>Payment</span>
            </v-btn>
          </div>
        </template>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import edit from '../../assets/image/icons/edit.png'
import link from '../../assets/image/icons/link.png'
import template from '../../assets/image/icons/template.png'
export default {
  props: ['value'],
  data() {
    return {
      toggle: this.value,
      edit: edit,
      link: link,
      template: template
    }
  },
  methods: {
    goToPageLineConnenct() {
      this.$emit('input', false)
      this.$emit('toggleToPagePlan')
    },
    back() {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped></style>
